'use client';
var IDENT_POPOVER_TARGET = "PopoverTarget";
var targetDefaultProps = {
    refProp: "ref",
    popupType: "dialog"
};

export { IDENT_POPOVER_TARGET, targetDefaultProps };
